import { Box, FormControlLabel, TextField, Switch } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  calendarOptions,
  detailsTickets,
  setDetailsTicketValue,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';
import ForwardIcon from '@material-ui/icons/Forward';
import { customFormat } from 'src/helpers/DateFormat';
import { ITicketDetails } from 'src/redux/Calendar/interfaces';
import { getPlaceholderFromDefaultValues } from 'src/helpers/calendar/getNormalisedValueFromInput';
import { useStyles } from './styles';

export const TicketsUpdateForm = ({
  comission,
  state,
  date,
  schedule_id,
}: {
  comission: string;
  state: ITicketDetails;
  date: string;
  schedule_id: string;
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ticket_type, rate_id } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const detailedData = useSelector(detailsTickets);
  const defaultTicket = data?.tickets.find((i) => i.id === ticket_type);

  if (!defaultTicket) return null;

  const changeState = (name: string, value: any) => {
    if (!detailedData) return;

    dispatch(
      setDetailsTicketValue({
        schedule_id,
        date,
        name,
        value,
      })
    );
  };

  return (
    <Box borderBottom={'0.8px solid rgba(0, 0, 0, 0.12)'}>
      <Box
        py={1}
        px={3}
        display="flex"
        alignItems="center"
        fontSize="16px"
        bgcolor="#f5f5f5"
        fontWeight={600}>
        {customFormat(date, 'MMMM DD YYYY')} ({state.sold_ts || 0} sold,{' '}
        {+(state.total_ts || defaultTicket.total_ts || 0) -
          +(state.sold_ts || 0)}{' '}
        available )
      </Box>
      <Box
        display="flex"
        px={3}
        pb={2}
        pt={3}
        justifyContent="center"
        flexWrap="wrap"
        gridGap="10px">
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.price,
              2
            )}
            value={state.price || ''}
            onChange={(e) => changeState('price', e.target.value || null)}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            label="Rate"
          />
          <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.strike_out,
              2
            )}
            value={state.strike_out || ''}
            onChange={(e) => changeState('strike_out', e.target.value || null)}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            label="Strikeout"
          />
          <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box> */}
        {/* <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            placeholder={getPlaceholderFromDefaultValues(comission)}
            value={state.commission || ''}
            onChange={(e) => changeState('commission', e.target.value || null)}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            label="Margin"
          />
          <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box>
        <Box mr={2} display="flex" alignItems="center">
          <TextField
            type="number"
            onChange={(e) => changeState('wholesale', e.target.value || null)}
            placeholder={getPlaceholderFromDefaultValues(
              defaultTicket.wholesale,
              2
            )}
            value={state.wholesale || ''}
            variant="outlined"
            className={classes.inputWrapper}
            InputProps={{
              style: {
                width: '120px',
                height: '40px',
                background: '#fff',
              },
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            label="Net"
          />
          <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
            <ForwardIcon style={{ rotate: '90deg' }} />
          </Box>
        </Box> */}
        {!rate_id && (
          <>
            {/* <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.min || ''}
                onChange={(e) => changeState('min', e.target.value || null)}
                placeholder={getPlaceholderFromDefaultValues(defaultTicket.min)}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                    background: '#fff',
                  },
                }}
                size="small"
                InputLabelProps={{ shrink: true }}
                label="Min"
              />
              <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
                <ForwardIcon style={{ rotate: '90deg' }} />
              </Box>
            </Box> */}
            <Box mr={2} display="flex" alignItems="center">
              <TextField
                type="number"
                value={state.total_ts || ''}
                onChange={(e) =>
                  changeState('total_ts', e.target.value || null)
                }
                placeholder={getPlaceholderFromDefaultValues(
                  defaultTicket.total_ts
                )}
                variant="outlined"
                className={classes.inputWrapper}
                InputProps={{
                  style: {
                    width: '120px',
                    height: '40px',
                    background: '#fff',
                  },
                }}
                size="small"
                InputLabelProps={{ shrink: true }}
                label="Total"
              />
              <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
                <ForwardIcon style={{ rotate: '90deg' }} />
              </Box>
            </Box>
            <Box display="flex" ml={6}>
              {/* <Box display="flex" alignItems="center" mr={4}>
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Disable Promos"
                  checked={Boolean(
                    state.disable_promos && +state.disable_promos
                  )}
                  onChange={(_, checked) =>
                    changeState("disable_promos", checked ? "1" : "0")
                  }
                />
                <Box style={{ opacity: 0 }} display="flex">
                  <ForwardIcon style={{ rotate: "90deg" }} />
                </Box>
              </Box> */}
              <Box display="flex" alignItems="center">
                <FormControlLabel
                  control={<Switch className={classes.customSwitch} />}
                  label="Stop Sell"
                  checked={Boolean(state.is_disabled && +state.is_disabled)}
                  onChange={(_, checked) =>
                    changeState('is_disabled', checked ? '1' : '0')
                  }
                />
                <Box style={{ opacity: 0 }} display="flex">
                  <ForwardIcon style={{ rotate: '90deg' }} />
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
